export const zero = "0px 0px 0px 0px rgba(0, 0, 0, 0)";

export const dark = {
	one: "0px 3px 8px 0px rgba(0, 0, 0, 0.5)",
	two: "0px 6px 12px 0px rgba(0, 0, 0, 0.3)",
	three: "0px 10px 20px 0px rgba(0, 0, 0, 0.1)",
};

export const light = {
	one: "0px 3px 8px 0px rgba(189,190,198, 0.5)",
	two: "0px 6px 12px 0px rgba(189,190,198, 0.3)",
	three: "0px 10px 30px 0px rgba(189,190,198, 0.3)",
};
